import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { ThemeStatus } from './../../../api/models/theme-status.model';

export const themesStatusAdapter: EntityAdapter<ThemeStatus>= createEntityAdapter<ThemeStatus>({
    selectId:(status:ThemeStatus)=>status.ThemeId
});

export interface ThemesStatusState extends EntityState<ThemeStatus>
{
    ids:number[];
    entities:any;
    loaded:boolean;
}